'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'compact-disc';
var width = 512;
var height = 512;
var aliases = [128191,128192,128440];
var unicode = 'f51f';
var svgPathData = ['M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm49-17.8c8.2-74.2 67.1-133.1 141.3-141.3c8.8-1 16.7 5.4 17.7 14.1s-5.4 16.7-14.1 17.7c-59.3 6.6-106.4 53.7-113 113c-1 8.8-8.9 15.1-17.7 14.1s-15.1-8.9-14.1-17.7zM352 256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z', 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompactDisc = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;